<template>
    <div>
        <p>トピック</p>
        <ul>
            <li :class="topic_id=='-1'?'selected':''">
                <a :href="'/thread'">全て表示</a>
            </li>
            <li v-for="topic in topic_list" :class="topic_id==topic.topic_id?'selected':''">
                <a :href="`/thread?topic_id=${topic.topic_id}`">{{ topic.title }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "topic-list",
        props: {
            topic_id: {
                type: String,
                default: '-1',
            },
            json_characters: {
                type:String,
                default: '',
            }
        },
        data: function () {
            return {
                topic_list: [],
                characters: Object,
            }
        },
        mounted() {
            this.getTopicList();
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            getTopicList: function() {
                axios.default
                    .get('/topic/list')
                    .then(response => {
                        if(this.topic_list.length == 0) {
                            this.topic_list = response.data;
                        } else {
                            this.topic_list = this.topic_list.concat(response.data);
                        }
                    });
            }
        }
    }
</script>
